import * as React from 'react';
import { Box, Container, Grid } from '@mui/material';
import Button from "@mui/material/Button";
import MUIDataTable from 'mui-datatables';
import { MuiThemeProvider } from '@material-ui/core/styles';
import Typography from '@mui/material/Typography';
import Paper from '@mui/material/Paper';
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import CheckIcon from '@mui/icons-material/Check';
import DoNotDisturbIcon from '@mui/icons-material/DoNotDisturb';
import TaskDialog from '../CreateDialogue/TaskDialog';
import EditTaskPropDialog from '../EditDialogue/EditTaskTypeDialog';
import EditTaskDialog from '../EditDialogue/EditTaskDialog';
import { Block } from '@material-ui/icons';
import { muiThemeDesign } from '../../mui-theme-design';
import { makeStyles } from "@mui/styles";
import Checkbox from '@mui/material/Checkbox';
import {logger, customBodyForExcelReport,handleExport,checkAuthentication,muiLoaderOptions} from '../../utils';
const ExcelJS = require('exceljs');

const pageStyles = makeStyles(theme => ({
    root: {
        "& .MuiPaper-root": {
            overflowy: "hidden"
        },
        "& .Mui-checked": {
            color: "#1f1b1e"
        },
        "& .MuiSvgIcon-root": {
            color: "#1f1b1e",
            colorPrimary: "#1f1b1e",
            fill: "#1f1b1e",
        },
 
    },
}));

export default function TasksTable() {

    const [refresh, setRefresh] = React.useState(true);
    const [tasks, setTask] = React.useState([]);
    const [isLoading, setIsLoading] = React.useState(true);
    const [permissions, setPermissions] = React.useState({});
    const [columns, setColumns] = React.useState([]);
    const [LockedAlert, setAlert] = React.useState(false);
    const [alertText, setAlertText] = React.useState("");
    const [filters, setFilters] = React.useState(['Active']);
    const [disableTaskId, setDisableTaskId] = React.useState(0);
    const [taskOperation, setTaskOperation] = React.useState(0);

    const classes = pageStyles();

    const handleDialogCallback = (childData) => {
        fetch("api/task", {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
                "task": [{
                    "ProjectID": childData.ProjectID,
                    "GroupID": childData.GroupID,
                    "CostCenterID": childData.CostCenterID,
                    "Name": childData.Name,
                    "IsBillable": childData.IsBillable,
                    "IsActive": childData.IsActive,
                }],
                "task_prop_item": childData.PropList
            })
        })
     //   logger(childData);
        setRefresh(true);
    };

    const handleEditCallback = (childData) => {

       fetch("api/task", {
            method: 'PATCH',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
                "task": {
                    "ProjectID": childData.ProjectID,
                    "GroupID": childData.GroupID,
                    "CostCenterID": childData.CostCenterID,
                    "Name": childData.Name,
                    "IsBillable": childData.IsBillable,
                    "IsActive": childData.IsActive,
                    "ID": childData.ID
                },
                "task_prop_item": childData.optionList
            })
        })
      //  logger(`Edit Callback`, childData);
        setRefresh(true);
    };
    
    const getPermissions = async () => {
	    const res = await fetch('/api/User/Permission');
	    const json = await res.json();
	    setPermissions(json);
	    logger('userTab Permissions-', json);
	    setRefresh(false);
	    setIsLoading(false);
	    return json;
	};
	
	const getTasks = async () => {
	    const res = await fetch('api/Task');
	    const json = await res.json();
	    setTask(json);
	    logger('userTab Tasks-', json);
	    return json;
	};

    React.useEffect(async () => {
		checkAuthentication();
        if (refresh) {
           var ta = await getTasks();
           var per = await getPermissions();
           
           var columns1 = [];
			if (per.CreateTasks == 1) {
				columns1 = [
				{
					name: "Admin Actions",
					options: {
						filter: false,
						sort: false,
						empty: true,
						customBodyRenderLite: (dataIndex, rowIndex) => {
							return (
								<div>
			
									<EditTaskDialog handleEditCallback={handleEditCallback} data={ta[dataIndex]} />
								</div>
							);
						}
			
					}
				},
				{
					name: "Name",
					label: "Name",
					options: {
						filter: true,
						filterType: "textbox",
		                sort: true,
		            }
		        },
		        {
		            name: "Project",
		            label: "Project",
		            options: {
		                filter: true,
		                sort: true,
		            }
		        },
		        {
		            name: "ProjectGroup",
		            label: "Project Group",
		            options: {
		                filter: true,
		                sort: true,
		            }
		        },
		        {
		            name: "IsActive",
		            options: {
		                filter: true,
		                sort: false,
		                empty: true,
		                filterList: filters,
						filterOptions: {
							names: ['InActive', 'Active'],
							logic: (isActive, filters, row) => {
								if (filters.includes('Active')) {
									return !(isActive === 1);
								} else if (filters.includes('InActive')) {
									return !(isActive === 0);
								}
								return false
							}
						},
		                customBodyRenderLite: (dataIndex, rowIndex) => {
		                    return (
		                        <div className={classes.root}>
		                        	<Checkbox checked={ta[dataIndex].IsActive} color="primary" className={classes.root} onClick={() => handleAlertOpen(ta[dataIndex])} />
		                        </div>
		                    );
		                }
		
		            }
		        },
		        {
		            name: "Billable",
		            options: {
		                filter: false,
		                sort: false,
		                empty: true,
		                customBodyRenderLite: (dataIndex, rowIndex) => {
		                    return (
		                        <div className={classes.root}>
		                            {(ta[dataIndex].IsBillable) ? <CheckIcon /> : <DoNotDisturbIcon />}
		                          
		                        </div>
		                    );
		                }
		            }
		        }
		    ];
			} else {
				columns1 = [
				{
					name: "Name",
					label: "Name",
					options: {
						filter: true,
						filterType: "textbox",
		                sort: true,
		            }
		        },
		        {
		            name: "Project",
		            label: "Project",
		            options: {
		                filter: true,
		                sort: true,
		            }
		        },
		        {
		            name: "ProjectGroup",
		            label: "Project Group",
		            options: {
		                filter: true,
		                sort: true,
		            }
		        },
		        {
					name: "IsActive",
					options: {
						filter: true,
						sort: false,
						empty: true,
						filterList: filters,
						filterOptions: {
							names: ['InActive', 'Active'],
							logic: (isActive, filters, row) => {
								if (filters.includes('Active')) {
									return !(isActive === 1);
								} else if (filters.includes('InActive')) {
									return !(isActive === 0);
								}
								return false
							}
						},
						customBodyRenderLite: (dataIndex, rowIndex) => {
							return (
								<div className={classes.root}>
									{(ta[dataIndex].IsActive) ? <CheckIcon /> : <DoNotDisturbIcon />}

								</div>
							);
		                }
		
		            }
		        },
		        {
		            name: "Billable",
		            options: {
		                filter: false,
		                sort: false,
		                empty: true,
		                customBodyRenderLite: (dataIndex, rowIndex) => {
		                    return (
		                        <div className={classes.root}>
		                            {(ta[dataIndex].IsBillable) ? <CheckIcon /> : <DoNotDisturbIcon />}
		                          
		                        </div>
		                    );
		                }
		            }
		        }
		    ];
			}
			setColumns(columns1);
        }
    });
    

    const handleAlertOpen = (task) => {
		setDisableTaskId(task.ID);
		if(task.IsActive){
			setAlertText(`Deactivate ${task.Name}?`);
			setTaskOperation(0);
		}else{
			setAlertText(`Activate ${task.Name}?`);
			setTaskOperation(1);
		}
		setAlert(true);
		setRefresh(false);
	};
	
	const handleAlertClose = () => {
		setAlert(false);
		setDisableTaskId(0);
		setAlertText("");
	};
    
    const deactivateTask = () => {
		setIsLoading(true);
		fetch(`api/task/${taskOperation}/${disableTaskId}`, {
            method: 'PUT',
        })
            .then(res => res.json())
            .then(json => {
            });
        setAlert(false);
        setRefresh(true);
	}


    const getSavedRowsPerPage = () => {
        const savedValue = localStorage.getItem('TaskrowsPerPage');
        return savedValue ? parseInt(savedValue) : 100; // Default value
    }
    // Save to local storage
    const saveRowsPerPage = (value) => {
        localStorage.setItem('TaskrowsPerPage', value.toString());
    }

    const initialRowsPerPage = getSavedRowsPerPage();

    const options = {
        filter: true,
        filterType: 'dropdown',
        responsive: 'vertical',
        selectableRows: 'none',
        rowsPerPage: initialRowsPerPage,
        rowsPerPageOptions: [10, 20, 50, 100],
        selectableRows: 'none',textLabels: {
			toolbar: {
			  search: "Search",
			  downloadCsv: "Download Excel", 
			  print: "Print",
			  viewColumns: "View Columns",
			  filterTable: "Filter Table",
				},
		}, onDownload: (buildHead, buildBody, columns, data) => {
			// Custom buildHead and buildBody functions
			const customBuildHead = () => {
				var newColumns = columns.map(column => column.label);
				return newColumns;
			}
		
			const customBuildBody = () => {
				const headers = customBuildHead();
				return customBodyForExcelReport({data:data, headers:headers, columnIndexToRemove:0});
			};
			
			const headers = customBuildHead();
			const rows = customBuildBody();
			//handleExport(rows, headers);
			handleExport({rows:rows, headers:headers, filename:'TaskList.xlsx', columnIndexToRemove:0})
			return false;
		},
		
		onFilterChange: (columnChanged, filterList) => {
            if(columnChanged == "IsActive") {
                setFilters(filterList[4]);
                setRefresh(true);
            }
        },
        customToolbar: () =>  permissions.CreateTasks===1 && !isLoading ?(<TaskDialog handleDialogCallback={handleDialogCallback} />):(<></>)
    };

    options.onChangeRowsPerPage = (newRowsPerPage) => {
        saveRowsPerPage(newRowsPerPage);
    };

    return (
        <Box>
            <MuiThemeProvider theme={muiThemeDesign}> 
            <Box style={{ minHeight: '100vh' }}>
                <MUIDataTable className="tasksTable"
                    title={
                        <Typography variant="h6" style={{ color: "white" }}>
                            Beyondsoft Tasks
                        </Typography>
                    }
                    data={isLoading ? [] :tasks}
                    columns={columns}
                    options={muiLoaderOptions(options, isLoading)}

                />
                </Box>
            </MuiThemeProvider>
			<Dialog
				open={LockedAlert}
				onClose={handleAlertClose}
				aria-labelledby="alert-dialog-title"
				aria-describedby="alert-dialog-description"
			>
				<DialogTitle id="alert-dialog-title">
					{taskOperation === 0 ? "De-Activate" : "Activate"}
				</DialogTitle>
				<DialogContent>
					<DialogContentText id="alert-dialog-description">
						{alertText}
					</DialogContentText>
				</DialogContent>
				<DialogActions>
					<Button onClick={deactivateTask} autoFocus>
						Confirm
					</Button>
					<Button onClick={() => {
						setAlert(false);
						setAlertText("");
					}}>
						Close
					</Button>
				</DialogActions>
			</Dialog> 
        </Box>
    );
}